module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('router-link', {
    staticClass: "btn btn-back",
    attrs: {
      "to": {
        'name': 'contact'
      },
      "tag": "button"
    }
  }, [_c('i', {
    staticClass: "icon-circle-left align-icon-left"
  }), _vm._v("\n        Voltar\n      ")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("\n        Ouvidoria\n      ")]), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-yellow"
  }), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-side-yellow"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('p', [_vm._v("Nós queremos saber sua opinião para melhorar sempre nossos processos, produtos e serviços.")]), _vm._v(" "), _c('p', {
    staticClass: "margin-20"
  }, [_vm._v("\n        Se você tiver alguma crítica referente à prestação de nossos serviços ou reclamação não solucionada pelos outros Canais\n        de Relacionamento, entre em contato com a nossa "), _c('b', [_vm._v("Ouvidoria")])]), _vm._v(" "), _c('p', [_vm._v("Basta ligar para o "), _c('b', [_vm._v("0800 765 3000")]), _vm._v(", de segunda à sexta-feira, das 8h às 17h.")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-info margin-30"
  }, [_c('b', {
    staticClass: "upper"
  }, [_vm._v("importante:")]), _vm._v(" antes de entrar em contato com a nossa "), _c('b', [_vm._v("Ouvidoria")]), _vm._v(", é preferível que você já tenha buscado solução\n        junto à nossa Central de Relacionamento e tenha aguardado o prazo informado para o atendimento de sua solicitação.\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 text-center"
  }, [_c('img', {
    staticClass: "ombudsman margin-20",
    attrs: {
      "src": require("../../../static/ombudsman.svg"),
      "alt": ""
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-9cc7f102!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/external/ombudsman.vue
// module id = 2195
// module chunks = 1